import { useEffect, useState } from 'preact/hooks';

/**
 * 389 (#1305, research R8) — "a full-screen prompt is open". The home pop-up sets it while it is open; the install offer
 * reads it and steps aside, so the customer never has two prompts on screen at once. The install offer is not made to
 * wait: on iOS it stays until dismissed (30 days), which would hide the pop-up from most iPhone users for weeks.
 */
let busy = false;
const listeners = new Set<(b: boolean) => void>();

export function isPromptSlotBusy(): boolean {
  return busy;
}

export function setPromptSlotBusy(next: boolean): void {
  if (busy === next) return;
  busy = next;
  for (const l of listeners) l(next);
}

/** Re-renders the caller whenever the flag changes. */
export function usePromptSlotBusy(): boolean {
  const [value, setValue] = useState(busy);
  useEffect(() => {
    listeners.add(setValue);
    setValue(busy);
    return () => {
      listeners.delete(setValue);
    };
  }, []);
  return value;
}
